"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToggle = exports.useOnClickOutside = exports.useFilterData = exports.isMouseOutTooltip = exports.isMouseOutParent = exports.isMouseOutJoin = void 0;
var _react = require("react");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useToggle = exports.useToggle = function useToggle() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useState = (0, _react.useState)(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var toggle = (0, _react.useCallback)(function () {
    return setState(function (state) {
      return !state;
    });
  }, []);
  return [state, toggle];
};
var useOnClickOutside = exports.useOnClickOutside = function useOnClickOutside(ref, handler) {
  (0, _react.useEffect)(function () {
    var listener = function listener(event) {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};
var useFilterData = exports.useFilterData = function useFilterData(data, key) {
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var handleFilter = data.filter(function (data) {
    return _lodash["default"].values(_lodash["default"].get(data, key, data)).some(function (val) {
      return _lodash["default"].includes(val.toString().toLowerCase(), value.toLowerCase());
    });
  });
  return [handleFilter, setValue];
};
var isMouseOutTooltip = exports.isMouseOutTooltip = function isMouseOutTooltip(e, tooltipId, parentId, placement) {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && document === undefined) {
    return true;
  }
  var x = e.clientX;
  var y = e.clientY;
  var positionParent = document.getElementById(parentId).getBoundingClientRect();
  var positionTooltip = document.getElementById(tooltipId).getBoundingClientRect();
  return !(placement === 'right' && (x >= positionTooltip.right || y <= positionTooltip.top || y >= positionTooltip.bottom || x < positionTooltip.left && (y <= positionParent.top || y >= positionParent.bottom)) || placement === 'left' && (x <= positionTooltip.left || y <= positionTooltip.top || y >= positionTooltip.bottom || x > positionTooltip.right && (y <= positionParent.top || y >= positionParent.bottom)) || placement === 'bottom' && (y >= positionTooltip.bottom || x <= positionTooltip.left || x >= positionTooltip.right || y < positionTooltip.top && (x <= positionParent.left || x >= positionParent.right)) || placement === 'top' && (y <= positionTooltip.top || x <= positionTooltip.left || x >= positionTooltip.right || y > positionTooltip.bottom && (x <= positionParent.left || x >= positionParent.right)));
};
var isMouseOutJoin = exports.isMouseOutJoin = function isMouseOutJoin(e, joinId, placement) {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && document === undefined) {
    return true;
  }
  var x = e.clientX;
  var y = e.clientY;
  var positionJoin = document.getElementById(joinId).getBoundingClientRect();
  return !((placement === 'right' || placement === 'left') && (y <= positionJoin.top || y >= positionJoin.bottom - 1) || (placement === 'bottom' || placement === 'top') && (x <= positionJoin.left || x >= positionJoin.right));
};
var isMouseOutParent = exports.isMouseOutParent = function isMouseOutParent(e, parentId, placement) {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && document === undefined) {
    return true;
  }
  var x = e.clientX;
  var y = e.clientY;
  var positionParent = document.getElementById(parentId).getBoundingClientRect();
  return !(placement === 'right' && (x <= positionParent.left || y <= positionParent.top || y >= positionParent.bottom) || placement === 'bottom' && (y <= positionParent.top || x <= positionParent.left || x >= positionParent.right) || placement === 'left' && (x >= positionParent.right || y <= positionParent.top || y >= positionParent.bottom - 1) || placement === 'top' && (y >= positionParent.bottom || x <= positionParent.left || x >= positionParent.right));
};